const KLAVIYO_SUBSCRIPTIONS_URL = "https://a.klaviyo.com/client/subscriptions/";
const KLAVIYO_API_REVISION = "2026-01-15";

class KlaviyoForm extends HTMLElement {
  onSubmit = async (event) => {
    event.preventDefault();

    const { listId, companyId, errorInvalid, errorGeneric } = this.dataset;

    if (!this.input.value.trim() || !this.input.checkValidity()) {
      this.showError(errorInvalid);
      return;
    }

    if (!listId || !companyId) {
      this.showError(errorGeneric);
      return;
    }

    this.clearError();
    this.button.disabled = true;

    try {
      const response = await fetch(
        `${KLAVIYO_SUBSCRIPTIONS_URL}?company_id=${encodeURIComponent(companyId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: KLAVIYO_API_REVISION,
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Footer signup form",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: this.input.value.trim(),
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED",
                            consented_at: new Date().toISOString(),
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: { data: { type: "list", id: listId } },
              },
            },
          }),
        },
      );

      if (!response.ok) throw new Error(response.status);

      // Swaps the form out for the confirmation message
      this.classList.add("success");
    } catch {
      this.showError(errorGeneric);
    } finally {
      this.button.disabled = false;
    }
  };

  clearError = () => {
    this.input.classList.remove("error");
    this.input.removeAttribute("aria-invalid");
    this.error.textContent = "";
  };

  connectedCallback() {
    this.form = this.querySelector("form");
    this.input = this.form?.elements.email;
    if (!this.input) return;

    this.button = this.form.querySelector("[type=submit]");
    this.error = this.form.querySelector("[data-error]");

    this.form.addEventListener("submit", this.onSubmit);
    this.input.addEventListener("input", this.clearError);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
    this.input?.removeEventListener("input", this.clearError);
  }

  showError(message) {
    this.input.classList.add("error");
    this.input.setAttribute("aria-invalid", "true");
    this.error.textContent = message;
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
